import React from 'react';
import { View } from 'react-native';
import ShimmerPlaceholder, { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';

const LoanScreenShimmer = () => {
  const ShimmerPlaceholderWithGradient = createShimmerPlaceholder(LinearGradient);

  return (
    <View style={{ padding: 16 }}>
      {/* Expiry Box */}
      <ShimmerPlaceholderWithGradient
        shimmerColors={['#ebebeb', '#ddd', '#ebebeb']}
        duration={1600}
        style={{
          width: '100%',
          height: 160,
          borderRadius: 12,
          marginBottom: 20,
        }}
      />

      {/* Buttons */}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <ShimmerPlaceholderWithGradient
          shimmerColors={['#ebebeb', '#ddd', '#ebebeb']}
          duration={1400}
          style={{
            width: '48%',
            height: 48,
            borderRadius: 8,
          }}
        />
        <ShimmerPlaceholderWithGradient
          shimmerColors={['#ebebeb', '#ddd', '#ebebeb']}
          duration={1400}
          style={{
            width: '48%',
            height: 48,
            borderRadius: 8,
          }}
        />
      </View>

    </View>
  );
};

export default LoanScreenShimmer;
